<template>
  <div
    class="ms-textarea ms-editor flex"
    :class="{error: errorProvider.isValid, disabled: disabled, 'ms-validate': isValidate}"
  >
    <label class="label" v-if="label">{{ label }}</label>

    <div class="flex-row border" :class="{error: errorMessage, disabled: disabled}">
      <textarea
        class="ms-textarea-item flex"
        :placeholder="placeholder"
        v-model="internalText"
        :disabled="disabled"
        ref="input"
        v-on="listeners"
        :maxlength="maxLength"
        :rows="rows"
        :readOnly="readOnly"
        :style="styleCustom"
        :class="{'font-small': heightOption == 1}"
      />
      <div class="icon24 error error-icon" v-if="errorMessage"></div>
    </div>
    <div class="error-text" v-if="errorMessage">
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import {useValidateControl} from '@/setup/validateControl.js';
import {getCurrentInstance} from '@vue/runtime-core';

export default {
  extends: msBaseComponent,
  name: 'MsTextarea',
  props: {
    styleCustom: {
      default: null,
      type: String,
    },
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    modelValue: {
      default: null,
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    //class chứa icon
    icon: {
      default: null,
      type: String,
    },
    /**
     * Số dòng
     */
    rows: {
      default: 4,
      type: Number,
    },
    /**
     * Tự động fit dòng với content
     */
    autoRows: {
      default: false,
      type: Boolean,
    },
    //ĐVThi 09/03/2021:  bổ sung Giới hạn nhập của ô input của TextArea
    maxLength: {
      default: null,
      type: Number,
    },
    preventPaste: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalText: this.modelValue,
      focused: false,
    };
  },
  computed: {
    listeners() {
      return {
        blur: e => {
          this.validate();
          this.onBlur(e);
        },
        focus: e => {
          this.onFocus(e);
        },
        change: e => {
          this.$emit('change', this.internalText, e);
        },
        keydown: e => {
          this.keyDownInput(e);
        },
        paste: e => this.pasteInput(e),
      };
    },
    heightOption() {
      return this.$store?.state?.dbOption?.dbOptions.HeightOption || 2;
    },
    lineHeight() {
      return this.$store.getters['dbOption/lineHeight'];
    },
    inputHeight() {
      return this.$store.getters['dbOption/inputHeight'];
    },
  },
  mounted() {
    const me = this;
    // Trường hợp để tự động điều chỉnh chiều cao và đang ở trong bảng => Chỉnh sửa lại style
    if (me.autoRows) {
      let lineHeight = me.lineHeight;
      let height = Math.max(Math.round(me.$refs.input.scrollHeight / lineHeight) * lineHeight - 2, me.inputHeight);
      me.$refs.input.style.height = height + 'px';
    }
  },
  setup(props) {
    const {proxy} = getCurrentInstance();

    const {errorMessage, validate, isValidate} = useValidateControl({props});

    /**
     * Xử lý event keydown
     */
    function keyDownInput(e) {
      const me = proxy;
      me.$emit(me.$ms.constant.CustomEvent.MsKeydown, e, me.internalText);
    }

    return {
      errorMessage,
      validate,
      isValidate,
      keyDownInput,
    };
  },
  methods: {
    //Sự kiện focus vào ô input
    onFocus(e) {
      const me = this;
      me.focused = true;
    },
    //Sự kiên blur ra ngoài ô input
    onBlur(e) {
      const me = this;
      me.focused = false;
    },
    //Reset lại giá trị về ban đầu
    reset() {
      const me = this;
      me.internalText = null;
    },
    //Set giá trị cho ô input
    setValue(value) {
      const me = this;
      me.internalText = value;
    },
    getValue() {
      const me = this;
      return me.internalText;
    },
    /**
     * Xử lý paste value
     */
    pasteInput(e) {
      if (this.preventPaste) {
        e.preventDefault();
      }
    },
  },
  watch: {
    internalText: {
      handler(newVal, oldVal) {
        const me = this;
        me.validate(newVal);
        me.$emit('update:modelValue', newVal);
        // Tự động điều chỉnh lại độ cao
        if (me.autoRows) {
          me.$refs.input.style.height = 'auto';
          let lineHeight = me.lineHeight;
          let height = Math.max(Math.round(me.$refs.input.scrollHeight / lineHeight) * lineHeight - 2, me.inputHeight);
          me.$refs.input.style.height = height + 'px';
        }
      },
    },
    modelValue: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        me.setValue(newVal);
      },
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/components/MsTextArea.scss';
</style>
